export default __webpack_public_path__ + "static/media/116-v-430.dc68ea59.png";